import React from 'react';
import { Link } from 'react-router-dom';

const PermissionDenied = () => {
  return (
    <div style={{ 
      backgroundColor: 'white', 
      padding: '40px', 
      borderRadius: '8px', 
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)', 
      textAlign: 'center',
      maxWidth: '600px',
      margin: '50px auto'
    }}>
      <h1 style={{ 
        fontSize: '28px', 
        fontWeight: 'bold', 
        color: '#c0392b',
        marginBottom: '20px' 
      }}>
        アクセス権限がありません
      </h1>
      <p style={{ 
        color: '#555', 
        fontSize: '16px', 
        marginBottom: '30px',
        lineHeight: '1.6'
      }}>
        この機能は、お客様が現在ご利用のプランではサポートされていません。
      </p>
      <Link 
        to="/subscription"
        style={{ 
          display: 'inline-block',
          backgroundColor: '#3498db',
          color: 'white', 
          fontWeight: 'bold', 
          padding: '12px 30px', 
          borderRadius: '5px', 
          textDecoration: 'none',
          transition: 'background-color 0.3s'
        }}
      >
        ご契約プランの確認・変更
      </Link>
    </div>
  );
};

export default PermissionDenied;
